import { apiHost } from '../../../config';
import { post } from '../../requests';
import School from '../../../types/School';

export default async function createSchool(school: Omit<School, 'id'>) {
  return post(`${apiHost}/api/admin/schools`, school);
}
